var Review = {
    aid: 0,
    stars: {},
    averageStars: {},
    rating: 0,
    title: '',
    review: '',
    formError: true,
    clickedStar: function(clicked) {
        // get the index of the star clicked
        const index = parseInt($(clicked).data('id'));
        let rating = 0;
        // loop through the stars and fill them to the index
        Review.stars.map(function(i, star) {
            if (parseInt($(star).data('id')) <= index) {
                $(star).find('path').addClass('star-full');
                rating++;
            } else {
                $(star).find('path').removeClass('star-full');
            }
        });
        // set the rating
        Review.rating = rating;
    },
    clearStars: function () {
        Review.stars.map(function(i, star) {
            if ($(star).find('path').hasClass('star-full')) {
                $(star).find('path').removeClass('star-full');
            }
        });
        // set the rating
        Review.rating = 0;
    },
    setAverageStars: function() {
        const averageStars = $('.average-stars');
        let lastRating = 0;
        averageStars.map(function(index, averageStar) {
            const stars = $(averageStar).find('div').children();
            const rating = Math.floor(parseInt($(averageStar).data('rating')));
            stars.map(function(i, star) {
                if (i < rating) {
                    $(star).find('path').addClass('star-full');
                }
                lastRating = rating;
            });
        });
        if (window.location.pathname.indexOf("/curator/review/edit/") > -1) {
            Review.rating = lastRating;
        }
    },
    clearForm: function() {
        Review.clearStars();
        $('#review-title').val('').keyup();
        $('#review').val('').keyup();
    },
    validateForm: function () {
        Review.formError = Review.title.length === 0 || Review.review.length === 0;

        if (Review.formError) {
            $('#review-submit').attr('disabled','disabled').removeClass('bg-green-800 hover:bg-green-900').addClass('bg-gray-700');
        } else {
            $('#review-submit').removeAttr('disabled').removeClass('bg-gray-700').addClass('bg-green-800 hover:bg-green-900');
        }
    },
    submit: function () {
        this.submitPromise()
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => {
                //console.log(error.response);
            });
    },
    submitPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.aid = Review.aid;
            request.rating = Review.rating;
            request.title = Review.title;
            request.review = Review.review;
            window.axios.post('/submit/review', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    },
    edit: function () {
        this.editPromise()
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => {
                //console.log(error.response);
            });
    },
    editPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.rid = $('#rid').val();
            request.visible = $('#visible').val();
            request.rating = Review.rating;
            request.title = $('#title').val();;
            request.review = $('#review').val();;
            window.axios.post('/curator/review/edit', request)
            .then((response) => {
                /*$('#messageDiv').addClass('bg-green-800').show();
                $('#message').html(response.data.title + ' has been edited.');*/
                window.location.pathname = $('#redirect').val();
            })
            .catch((error) => {
                //console.log(error);
                //console.log(error.response);
                let message = error.response.data.message;
                $('#message').text(message);
                $('#messageDiv').removeClass('bg-green-800').addClass('bg-red-800').show();

                $.each(error.response.data.errors, function(key, value) {
                    //console.log("key = " + key);
                    //console.log("value = " + value);
                    let messageText = '#' + key + "Error";
                    $(messageText).text(value).show();
                    if ($('#' + key).hasClass('border-gray-700')) {
                        $('#' + key).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    
                });
            });
        });
    },
    resetErrors: function() {
        $.each($('input, textarea'), function(key, value) {
            if ($(this).hasClass('border-red-800')) {
                $(this).removeClass('border-red-800').addClass('border-gray-700');
                $(this).parent().find('span').hide();
                $('#messageDiv').removeClass('bg-red-800').removeClass('bg-green-800').hide();
            }
        });
        $.each($('select'), function(key, value) {
            if ($(this).hasClass('border-red-800')) {
                $(this).removeClass('border-red-800').addClass('border-gray-700');
                $(this).parent().parent().find('span').hide();
                $('#messageDiv').removeClass('bg-red-800').removeClass('bg-green-800').hide();
            }
        });
    },
}

$(document).ready(function() {
    // get the stars
    Review.aid = $('#aid').data('aid');
    Review.stars = $('#stars').find('div').children();
    Review.setAverageStars();

    // add click listener for stars
    $(Review.stars).on('click', function(e) {
        Review.clickedStar(this);
    });
    // add click listener for clear stars
    $('#clear-stars').on('click', function(e) {
        Review.clearStars();
    });
    // keyup listeners for the inputs
    $('#review-title').on('keyup', function(e) {
        Review.title = $(this).val();
        Review.validateForm();
    });
    $('#review').on('keyup', function(e) {
        Review.review = $(this).val();
        Review.validateForm();
    });
    // review buttons
    $('#review-clear').on('click', function(e) {
        Review.clearForm();
    });
    $('#review-submit').on('click', function(e) {
        Review.submit();
    });
    // review content
    $('.reviewDown').on('click', function(e) {
        const row = $(this).closest('.review-row');
        const title = $(row).find('.review-title');
        const up = $(this).parent().find('.reviewUp');
        const down = $(this);
        const content = $(row).find('.review-content');

        $(up).show();
        $(down).hide();
        $(title).hide();
        $(content).slideDown();
    });
    $('.reviewUp').on('click', function(e) {
        const row = $(this).closest('.review-row');
        const title = $(row).find('.review-title');
        const up = $(this);
        const down = $(this).parent().find('.reviewDown');
        const content = $(row).find('.review-content');

        $(up).hide();
        $(down).show();
        $(content).slideUp(() => { $(title).show() });
    });
    // edit review
    $('#editReview').on('click', function(e) {
        Review.resetErrors();
        Review.edit();
    });
});